<template>
    <div>
    <Header></Header>
    <Login></Login>
    <div class="productIntro-list">
        <div class="productIntro-list-item" v-for="(item,index) in productIntroList" :key="index">
            <div class="product-item-info" :style="{background:'url('+item.productIntroItemBg+') 0% 0% / 100% 100%'}">
                <div class="productIntro-item-info-wrapper">
                  <div>
                    <div class="productIntro-item-title">{{item.productIntroItemTitle}}</div>
                    <div class="productIntro-item-title-content">澜城数据通过互联网海量手机加人力核验方式沉淀了海量楼盘数据，构建了收录上海真实楼盘信息数据库，上海楼盘<span>1.6万小区、80万幢、1000万套房屋</span>的物理信息，房屋级地址以产证地址为标准。在此基础上研发楼盘库应用工具，实现用小区和地址的全域匹配，实现了房源、成交案例等经纪业务全链信息化。该系统工具可延伸至澜城数据的所有应用产品，以及支持API接口支持用户企业内部使用。</div>
                  </div>
                  <div class="productIntro-item-img"><img src="../assets/images/productIntro/开放平台bg@2x.png" /></div>
                </div>
            </div>
            <div class="product-advantage">
                <div class="product-advantage-title">产品优势</div>
                <div class="product-advantage-enTitle">Product Advantages</div> 
                <div class="product-advantage-list">
                    <div class="product-advantage-list-item" v-for="(v,i) in item.productAdvantageList" :key="i">
                        <div class="product-advantage-list-item-wrapper">
                            <div class="product-advantage-img">
                                <img :src="v.productAdvantageIcon" alt="">
                            </div>
                            <div class="product-advantage-text">{{v.productAdvantageTitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-function">
                <div class="product-function-title">产品主要功能</div>
                <div class="product-function-enTitle">The Main Function of The Product</div>
                <div class="product-function-list">
                    <div class="product-function-list-wrapper">
                      <div class="product-function-list-wrapper-left">
                        <img v-if="productFunctionDetailId === 0" class="product-function-img" src="../assets/images/productIntro/主要功能-开放平台1@2x.png" />
                        <img v-if="productFunctionDetailId === 1" class="product-function-img" src="../assets/images/productIntro/主要功能-开放平台2.png" />
                        <img v-if="productFunctionDetailId === 2" class="product-function-img" src="../assets/images/productIntro/主要功能-开放平台3.png" />
                      </div>
                      <div class="product-function-list-wrapper-right">
                        <div class="product-function-detail-list">
                          <div class="product-function-detail-list-item" v-for="(vv,ii) in item.productFunctionDetailList" :key="ii"  @click="productFunctionDetailItemClick(ii)">
                            <div :class="['product-function-detail-title',ii === productFunctionDetailId ? 'active': '' ]">{{vv.productFunctionDetailTitle}}</div>
                            <div class="product-function-detail-text">{{vv.productFunctionDetailText}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="customer-case">
                <div class="customer-case-title">客户案例</div>
                <div class="customer-case-enTitle">Customer Case</div>
                <div class="customer-case-content">
                   <div class="customer-case-content-wrapper">
                      <div class="customer-case-content-title">{{item.customerCaseContentTitle}}</div>
                      <div class="customer-case-content-text">{{item.customerCaseContentText}}</div>
                   </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  name: "productIntro",
  components: {
    Header,
    Footer,
    Login
  },
  data() {
    return {
      productIntroList: [
        {
          id: 3,
          productIntroItemBg: require("../assets/images/productIntro/banner-bg@2x.png"),
          productIntroItemTitle: "澜城数据开放平台",
          productIntroItemContent:
            "澜城数据通过互联网海量手机加人力核验方式沉淀了海量楼盘数据，构建了收录上海真实楼盘信息数据库，上海楼盘",
          productAdvantageList: [
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_openplatform0.png"),
              productAdvantageTitle: "楼盘框架共享"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_openplatform2.png"),
              productAdvantageTitle: "楼盘属性信息交互"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_openplatform1.png"),
              productAdvantageTitle: "可衔接澜城数据所有系统产品"
            }
          ],
          productFunctionDetailList: [
            {
              // productFunctionImgUrl: require("../assets/images/productIntro/主要功能-开放平台1@2x.png"),
              productFunctionDetailTitle:
                "楼盘库开放平台1.0主要解决楼盘框架相关",
              productFunctionDetailText:
                "可对接企业内部系统，解决信息孤岛，大大提升企业内部管理"
            },
            {
              // productFunctionImgUrl: "",
              productFunctionDetailTitle: "楼盘、幢、室号自定义",
              productFunctionDetailText:
                "可根据企业内部业务划分自定义划分小区边界"
            },
            {
              // productFunctionImgUrl: "",
              productFunctionDetailTitle: "房源匹配及自定义关联地址",
              productFunctionDetailText:
                "可根据企业内部房源地址进行关联匹配，形成楼盘统一性"
            }
          ],
          // customerCaseBgUrl: require("../assets/images/productIntro/客户案例-开放平台bg@2x.png"),
          customerCaseContentTitle: "太平洋房屋重建房客源管理系统",
          customerCaseContentText:
            "为太屋房客源管理系统、太屋外网提供了楼盘字典基础数据。提供维护服务，并结合澜城数据成交案例数据，实现了企业数字化管理。"
        }
      ],
      productFunctionDetailId: 0
    };
  },
  methods: {
    productFunctionDetailItemClick(ii) {
      this.productFunctionDetailId = ii;
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.productIntro-list {
  width: 100%;

  .productIntro-list-item {
    width: 100%;

    .product-item-info {
      .productIntro-item-info-wrapper {
        display: flex;
        width: 1140px;
        height: 600px;
        margin: 0 auto;
        overflow: hidden;

        .productIntro-item-title {
          width: 384px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #272727;
          line-height: 45px;
          margin-top: 200px;
        }

        .productIntro-item-title-content {
          width: 400px;
          height: 168px;
          margin-top: 32px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #666666;
          line-height: 28px;

          span {
            color: #272727;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
        }

        .productIntro-item-img {
          width: 626px;
          height: 100%;
          margin-left: 131px;
          padding-top: 71px;

          img {
            width: 626px;
            height: 426px;
          }
        }
      }
    }

    .product-advantage {
      width: 100%;
      overflow: hidden;

      .product-advantage-title {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        text-align: center;
        color: #272727;
        line-height: 40px;
        margin-top: 56px;
      }

      .product-advantage-enTitle {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #999999;
        line-height: 22px;
        letter-spacing: 2px;
      }

      .product-advantage-list {
        width: 1140px;
        height: 128px;
        margin: 0 auto;
        margin-top: 56px;
        display: flex;
        justify-content: space-around;

        .product-advantage-list-item {
          width: 350px;
          height: 128px;
          background: rgba(56, 128, 244, 0.06);
          overflow: hidden;

          .product-advantage-list-item-wrapper {
            margin: 32px 0px 32px 30px;
            display: flex;

            .product-advantage-img {
              width: 64px;
              height: 64px;
              background: #fff;
              border-radius: 50%;
              position: relative;

              img {
                width: 32px;
                height: 32px;
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
            .product-advantage-text {
              width: 192px;
              margin-left: 32px;
              height: 64px;
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #272727;
              line-height: 64px;
            }
          }
          &:last-child .product-advantage-text {
            line-height: 34px;
          }
        }
      }
    }

    .product-function {
      width: 100%;

      .product-function-title {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        text-align: center;
        color: #272727;
        line-height: 40px;
        margin-top: 100px;
      }

      .product-function-enTitle {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #999999;
        line-height: 22px;
        letter-spacing: 2px;
      }

      .product-function-list {
        margin-top: 56px;

        .product-function-list-wrapper {
          width: 1140px;
          margin: 0 auto;
          overflow: hidden;

          .product-function-list-wrapper-left {
            width: 50%;
            float: left;

            .product-function-img {
              width: 582px;
              height: 457px;
              display: block;
            }
          }

          .product-function-list-wrapper-right {
            width: 50%;
            float: left;

            .product-function-detail-list {
              .product-function-detail-list-item {
                width: 471px;
                height: 114px;
                margin: 0 auto;
                margin-bottom: 48px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                &:hover .product-function-detail-title {
                  color: #3880f4;
                }

                .product-function-detail-title {
                  height: 22px;
                  font-size: 16px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #272727;
                  line-height: 22px;
                  position: relative;
                  cursor: pointer;

                  &.active {
                    color: #3880f4;

                    &::after {
                      content: "";
                      width: 3px;
                      height: 20px;
                      background: #3880f4;
                      border-radius: 1px;
                      position: absolute;
                      left: -24px;
                      top: 2px;
                    }
                  }
                }

                .product-function-detail-text {
                  height: 20px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  line-height: 20px;
                  margin-top: 24px;
                }

                &:last-child {
                  border: none;
                }
              }
            }
          }
        }

        // .product-function-item {
        //   width: 1140px;
        //   margin: 0 auto;

        //   .product-function-item-left {
        //     width: 50%;
        //     float: left;

        //     img {
        //       width: 504px;
        //     }
        //   }

        //   .product-function-item-right {
        //     width: 50%;
        //     height: 457px;
        //     float: left;
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;

        //     .product-function-item-title {
        //       width: 417px;
        //       height: 70px;
        //       font-size: 16px;
        //       font-family: PingFangSC-Medium, PingFang SC;
        //       font-weight: 500;
        //       color: #3880f4;
        //       line-height: 22px;
        //       border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        //       position: relative;
        //       cursor: pointer;

        //       &::after {
        //         content: "";
        //         width: 3px;
        //         height: 20px;
        //         background: #3880f4;
        //         border-radius: 1px;
        //         position: absolute;
        //         left: -24px;
        //         top: 2px;
        //       }
        //     }
        //   }
        // }
      }
    }

    .customer-case {
      overflow: hidden;
      padding-bottom: 100px;

      .customer-case-title {
        margin-top: 84px;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        text-align: center;
        color: #272727;
        line-height: 40px;
      }

      .customer-case-enTitle {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #999999;
        line-height: 22px;
        letter-spacing: 2px;
      }

      .customer-case-content {
        width: 1140px;
        height: 133px;
        margin: 0 auto;
        margin-top: 56px;
        background: url("../assets/images/productIntro/客户案例-开放平台bg@2x.png")
          no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.01);
          transition: all 0.3s ease;
        }

        .customer-case-content-wrapper {
          margin: 32px 56px 0 56px;

          .customer-case-content-title {
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #272727;
            line-height: 25px;
          }

          .customer-case-content-text {
            height: 40px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin-top: 24px;
          }
        }
      }
    }
  }
}
</style>


